const scrollToId = id => {
  const element = document.getElementById(id);
  const root = document.getElementsByTagName('html')[0];
  const getPosition = el => el.getBoundingClientRect().top;
  const elementPosition = getPosition(element);
  const rootPosition = getPosition(root);

  const dest = elementPosition - rootPosition;
  window.scrollTo({
    top: dest,
    behavior: 'smooth'
  });
};

export default scrollToId;
